export const ACTION_WELCOME = "ACTION_WELCOME";
export const ACTION_UPDATE_MARCAEMPRESARIAL = 'ACTION_UPDATE_MARCAEMPRESARIAL';
export const ACTION_CREATE_MARCAEMPRESARIAL = 'ACTION_CREATE_MARCAEMPRESARIAL';
